module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "width": "600px",
      "before-close": _vm.handleCancel,
      "visible": _vm.isVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "matrixForm",
    attrs: {
      "label-position": "right",
      "label-width": "150px",
      "model": _vm.matrixForm,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Question",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.matrixForm.title),
      callback: function($$v) {
        _vm.$set(_vm.matrixForm, "title", $$v)
      },
      expression: "matrixForm.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Choices"
    }
  }, [_c('draggable', {
    attrs: {
      "group": "matrix-sub-choices",
      "draggable": ".draggable"
    },
    model: {
      value: (_vm.choices),
      callback: function($$v) {
        _vm.choices = $$v
      },
      expression: "choices"
    }
  }, _vm._l((_vm.choices), function(choice, index) {
    return _c('div', {
      key: index,
      staticClass: "choice-item container-fluid draggable"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-9"
    }, [_c('strong', [_vm._v(_vm._s(index + 1) + ".")]), _vm._v("\n              " + _vm._s(choice.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('span', {
      staticClass: "choice-tools pull-right"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "Remove"
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-trash",
      on: {
        "click": function($event) {
          return _vm.handleRemoveChoice(index)
        }
      }
    })])], 1)])])])
  }), 0), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "Add new choice"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleAddChoice($event)
      }
    },
    model: {
      value: (_vm.choiceInput),
      callback: function($$v) {
        _vm.choiceInput = $$v
      },
      expression: "choiceInput"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.matrixChoicesCreating,
      "disabled": _vm.matrixChoicesCreating
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v(_vm._s(_vm.matrixForm.id ? 'Save' : 'Create'))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b11450a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/surveybuilder/dialogs/MatrixChoiceSaveDialog.vue
// module id = 3193
// module chunks = 3